import React, { useState } from "react";
import * as StockService from "../../../../services/StockServices";
import PaginateList from "../../../utils/PaginateList";
import { STOCK_STATUS } from "../../../../constants/index";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  checkBootstrapSizeBreak,
  SIZES,
} from "../../../../utils/device/checkDevice";
import { getDateFormatTimeZone } from "../../../../utils/formats";

const StockListContainer = ({ filters, sortBy }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const deviceSize = checkBootstrapSizeBreak();
  const [forceRefresh, setForceRefresh] = useState(false);

  const columns = [
    {
      header: t("forms.stock.table.head.date"),
      accessorKey: "date",
      cell: (info) =>
        getDateFormatTimeZone(info.getValue(), "DD-MM-yyyy HH:mm"),
      size: 200,
    },
    {
      header: t("forms.stock.table.head.batch"),
      accessorKey: "batch",
      cell: (info) => info.getValue(),
    },
    {
      header: t("forms.stock.table.head.itemCode"),
      accessorKey: "itemCode",
      cell: (info) => info.getValue(),
    },
    {
      header: t("forms.stock.table.head.harvestYear"),
      accessorKey: "harvestYear",
      cell: (info) => info.getValue(),
    },

    {
      header: t("forms.stock.table.head.weight"),
      accessorKey: "weight",
      cell: (info) => info.getValue(),
    },
    {
      header: t("forms.stock.table.head.locationStorageCode"),
      accessorKey: "locationStorageCode",
      cell: (info) => info.getValue(),
    },
    {
      header: t("forms.stock.table.head.batchOrder"),
      accessorKey: "output.orderProduct.batch",
      cell: (info) => info.getValue(),
    },
    {
      header: t("forms.stock.table.head.status"),
      accessorKey: "status",
      cell: (info) => {
        if (info.row.original.status) {
          const cat = STOCK_STATUS.find(
            (c) => c.code === info.row.original.status,
          );
          return t(cat.label);
        }
        return "";
      },
    },
    // {
    //   header: t("forms.order.table.head.actions"),
    //   accessorKey: "uuid",
    //   cell: (info) => renderAction(info.row.uuid),
    // },
  ];

  // const renderAction = (data) => {
  //   return (data)}

  const listData = async (filter) => {
    if (sortBy) {
      filter.sort = sortBy;
    } else {
      filter.sort = "-date";
    }
    const result = await StockService.listFilterStock(filter);
    return result;
  };

  const hide = {};
  let resize = null;

  if (deviceSize < SIZES.md) {
    hide.itemCode = false;
    resize = false;
  } else if (deviceSize === SIZES.md) {
    hide.itemCode = false;
  }
  return (
    <>
      <PaginateList
        refresh={forceRefresh}
        filters={filters}
        columns={columns}
        toList={listData}
        hideColum={hide}
        resize={resize}
        resetRefresh={() => setForceRefresh(false)}
      ></PaginateList>
    </>
  );
};

export default StockListContainer;
